export default __webpack_public_path__ + "static/media/fastic.ec06e3e4.png";